import { render } from "./MovieCatalog.vue?vue&type=template&id=2635db01&scoped=true"
import script from "./MovieCatalog.vue?vue&type=script&lang=js"
export * from "./MovieCatalog.vue?vue&type=script&lang=js"

import "./MovieCatalog.vue?vue&type=style&index=0&id=2635db01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2635db01"]])

export default __exports__